<template>
  <el-row>
    <a class="download-button" style="float:right;cursor:pointer"
        @click="showTopicForm"
             >
             Add Post
    </a>
    <div style="float:right;cursor:pointer">
      &nbsp;
    </div>
    <a class="download-button" style="float:right;cursor:pointer"
        @click="closeTopic(1)" v-if="showClose"
             >
             Close Topic
    </a>
    <div style="float:right;cursor:pointer">
      &nbsp;
    </div>
    <a class="download-button" style="float:right;cursor:pointer"
        @click="closeTopic(0)" v-if="showOpen"
             >
             Reopen Topic
    </a>
    <div id="topicForm" style="display:none">
        <el-form ref="form"
                 :model="form"
                 label-position="top">
          <el-form-item >
		              <el-input type="textarea"
                      :rows="5"
                      v-model="form.content"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary"
                       @click="addPost()">Post</el-button>
          </el-form-item>
        </el-form>
    </div>
Topic:{{closedOrNot}}<el-input type="text"
                      :readonly="true"
					  v-model="topic.topic"
                ></el-input>
<br />
<br />
                Description:
<br />
<br />
<el-input type="textarea"
                      :rows="5" :readonly="true"
					  v-model="topic.content"
                ></el-input>
	

    <el-table :data="postList"
              style="width: 100%">
      <el-table-column prop="post.post_content"
                       label="Posts">
      </el-table-column>
     <el-table-column prop="post.create_date"
                       label="Date" style="float:right"
					   >
      </el-table-column>
    </el-table>
  </el-row>
</template>

<script>
export default {
  created() {
	  this.getTopic();
    this.getPosts();
    //this.form = {topic: 'default topic'};
  },
  data() {
    return {
      headers: { Authorization: 'Bearer ' + localStorage.token },
	    postList: [],
	    topic: '',
      token: localStorage.token,
      form: {},
      showClose: false,
      showOpen: false,
      closedOrNot: ''
    };
  },
  methods: {
    showTopicForm(){
      topicForm.style.display = 'block';

    },
    getPosts() {
      this.axios({
        method: 'get',
        url: `/posts/${this.$route.params.userID}/${this.$route.params.topicID}`,
      }).then(res => {
		this.postList = res.data.posts;
		//console.log(this.postList);
      });
    },
    getTopic() {
      this.axios({
        method: 'get',
        url: `/posts/topic/${this.$route.params.userID}/${this.$route.params.topicID}`,
      }).then(res => {
        this.topic = res.data.topic;
        if(this.topic.is_closed != 0){
          this.closedOrNot = '(Closed)';
          this.showOpen = true;
          this.showClose = false;
        }
        else{
          this.closedOrNot = '(Not Closed)';
          this.showOpen = false;
          this.showClose = true;
        }
      });
    },
    addPost() {
//      this.$refs['form'].validate(valid => {
//        if(valid){

//      console.log(this.form);

      this.axios({
        method: 'put',
        url: `/posts/${this.$route.params.userID}/${this.$route.params.topicID}/add`,
        data: this.form
      }).then(res => {
        this.getPosts();
        topicForm.style.display = 'none'
        this.$message({
          message: 'Replying success!',
          type: 'success',
        });
      });


        //   return true;
        // }
        // else{
        //   return false;
        // }
      //};
    },

    closeTopic(isClose) {
      //console.log(row);
      let msg, action, code;
      if (isClose == 1){
        action = 'close';
        code = 1;
      }
      else{
        action = 'open';
        code = 0;
      }
      msg = 'Are you sure to ' + action + ' the topic?';
      this.$confirm(
        msg,
        'Message',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      )
        .then(() => {
// console.log(row.topic.id);
          this.axios({
            method: 'get',
            url: `/topics/${this.$route.params.userID}/${code}/close`,
            params: {
              id: this.topic.id,
            },
          }).then(res => {
            if (res.data.success) {
              // this.topicList = this.topicList.filter(
              //   row => row.topic.id !== topic.id
              // );
              this.getTopic();

              //this.getTabs();
              this.$message({
                center: true,
                message: action + ' Success',
                type: 'success',
                showClose: true,
              });
            } else {
              this.$message({
                center: true,
                message: action + ' Fail',
                type: 'fail',
                showClose: true,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: action + ' canceled',
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme/element-variables';
.download-button {
  color: #ffffff;
  background-color: $--color-primary;
  border: 1px solid $--color-primary;
  border-radius: 3px;
  padding: 9px 15px;
  font-size: 12px;
  display: inline-block;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/user/PostList.vue